<div class="layout-container" [ngClass]="containerClass">
  <app-topbar></app-topbar>
  <app-sidebar></app-sidebar>

  <div class="layout-content-wrapper">
    <div class="layout-content">
      <div class="">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>